<template>
  <a-form class="form" layout="vertical" :model="formState" ref="formRef">
    <a-form-item name="name" label="Nombre de la plantilla" required>
      <a-input v-model:value="formState.name" placeholder="Escribir nombre de la plantilla" />
    </a-form-item>

    <a-form-item name="description" label="Descripción">
      <a-textarea
        v-model:value="formState.description"
        :autosize="{ minRows: 3, maxRows: 3 }"
        placeholder="Escribe aquí"
      />
    </a-form-item>
    <h3>Selecciona las campañas a la que deseas asociar a tu plantilla</h3>
    <a-form-item name="name" required>
      <CampaignPicker
        v-model:value="formState.portfolios"
        withName
        withOutEntity
        multiple
        :showAll="false"
        label="Campañas asociadas"
        placeholder="Sin campañas asociadas"
      />
    </a-form-item>
    <a-form-item
      v-if="template ? false : templateType === TemplateType.Html"
      name="html_file"
      label="Archivo HTML"
      required
    >
      <ArchivePicker v-model:value="formState.html_file" :supportedTypes="['.html']" />
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { FormInstance } from "ant-design-vue";
import { reactive, ref, watch } from "vue";

import { CreateTemplateDto } from "@/@types/flows/emailTemplates/dtos";
import { Template, TemplateType } from "@/@types/flows/emailTemplates";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";

import ArchivePicker from "@/app/shared/components/molecules/ArchivePicker.vue";
import { debounce } from "lodash";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";

const props = defineProps<{ templateType: TemplateType | undefined; template?: Template }>();

const formRef = ref<FormInstance>();
const formState: Partial<CreateTemplateDto> & { html_file?: File } = reactive({
  name: props.template?.name ?? "",
  description: props.template?.description ?? undefined,
  html_file: undefined,
  // portfolios: [...new Set(props.template?.queues.flatMap((q) => q.portfolios.map((p) => p.id)))] || [],
  portfolios: props.template?.portfolios.map((el: any) => el.id) ?? [],
});

const validate = async () => {
  await formRef.value?.validate();
};

watch(
  () => props.template,
  (value) => {
    formState.name = props.template?.name ?? ""
    formState.description = props.template?.description ?? undefined
    formState.html_file = undefined
    formState.portfolios = props.template?.portfolios.map((el: any) => el.id) ?? []
  }
);

watch(
  formState,
  debounce(() => {
    if (!props.template) return;

    emailTemplateService.update(props.template.id, {
      name: formState.name,
      description: formState.description,
      portfolios: formState.portfolios,
    });
  }, 500)
);

defineExpose({ validate, formState });
</script>

<style scoped lang="sass"></style>
